var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTg = function SvgIconTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#496E2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c-.008 0-.521 4.8-.521 4.8H21.6A11.98 11.98 0 0 0 12 0M12 24c3.926 0 7.411-1.885 9.6-4.8H2.4A11.98 11.98 0 0 0 12 24M23.76 9.6H11.478L12 14.4h11.76a12.05 12.05 0 0 0 0-4.8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 14.4V0C5.373 0 0 5.373 0 12c0 .822.083 1.624.24 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m6.622 5.738.777 2.392h2.514L7.88 9.608l.777 2.391-2.034-1.478L4.587 12l.777-2.391L3.33 8.13h2.515z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTg;